import { render, staticRenderFns } from "./DashboardCd.vue?vue&type=template&id=88d468e0"
import script from "./DashboardCd.vue?vue&type=script&lang=js"
export * from "./DashboardCd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports